import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { ThirdAuthUser } from '../../interfaces/auth.interface';
import { PipesModule } from '../../pipes/pipes.module';
import { CSIconButtonComponent } from '../cs-icon-button/cs-icon-button.component';
import { CustomizeFormModule } from '../customize-form/customize-form.module';
import { OtherLogins, ThirdAuthM8Service } from './third-auth-m8.service';

@UntilDestroy()
@Component({
  selector: 'app-third-auth-m8',
  templateUrl: './third-auth-m8.component.html',
  styleUrls: ['./third-auth-m8.component.scss'],
  imports: [CommonModule, FormsModule, PipesModule, CustomizeFormModule, MatCheckboxModule, CSIconButtonComponent],
  standalone: true,
})
export class ThirdAuthM8Component implements OnInit {
  constructor(
    public thirdAuthM8Service: ThirdAuthM8Service,
    private appService: AppService,
  ) {}

  /**其他登录方式 */
  otherLogins: OtherLogins[] = [];

  @Input() type: 'login' | 'wallet' = 'login';

  // 是不是在註冊或登入頁面
  @Input() isRegLogPage: boolean = true;

  @Input() actionFrom: string = '';

  @Output()
  clickAuthName: EventEmitter<ThirdAuthUser> = new EventEmitter();

  @Output()
  clickIframeAuth: EventEmitter<OtherLogins> = new EventEmitter();

  thirdPartyWallets: ThirdAuthUser[] = [
    ThirdAuthUser.MetaMask,
    ThirdAuthUser.WalletConnect,
    ThirdAuthUser.CoinbaseWallet,
    ThirdAuthUser.TonConnect,
  ];
  thirdPartyLogins: ThirdAuthUser[] = [
    ThirdAuthUser.Google,
    ThirdAuthUser.Line,
    ThirdAuthUser.Facebook,
    ThirdAuthUser.Telegram,
    ThirdAuthUser.X,
  ];

  ngOnInit(): void {
    this.thirdAuthM8Service.reset();
    this.appService.tenantConfig$.subscribe(value => {
      const openedSocialLogin = value?.openedSocialLogin;

      // Only show TonConnect when using TG Mini App
      const isTgApp = sessionStorage.getItem('isTgApp') === 'true';
      if (isTgApp) {
        this.thirdPartyWallets = [ThirdAuthUser.TonConnect];
        this.thirdPartyLogins = [ThirdAuthUser.Telegram];
      }

      if (openedSocialLogin && openedSocialLogin.length > 0) {
        this.otherLogins = this.thirdAuthM8Service.buildThirdPartyInfo(
          this.type === 'login' ? this.thirdPartyLogins : this.thirdPartyWallets,
        );
      }
    });
  }

  /**
   * 第三方验证
   *
   * @param authName
   */
  loginVer(authName: ThirdAuthUser): void {
    this.thirdAuthM8Service.actionFrom$.next(this.actionFrom);
    this.clickAuthName.emit(authName);
    this.thirdAuthM8Service.handleAuth({ authName, isRegLogPage: this.isRegLogPage });
  }

  /**监听子iframe发回的 click 事件 */
  buildClick(item: OtherLogins) {
    this.thirdAuthM8Service.handleBuildClick(item, () => {
      if (this.clickIframeAuth.observers.length > 0) {
        this.clickIframeAuth.emit(item);
      } else {
        this.loginVer(item.name);
      }
    });
  }
}
